import states from '../contact/states.js';

export const _forms = {
  title: {
    login: 'Log In',
  },
  actions: {
    login: 'requestLogin',
    register: 'requestRegisterUser',
    reset: 'requestResetPassword',
    confirm: 'requestConfirmPassword',
    verify: 'requestAccountVerification',
    resetPassword: 'requestConfirmPassword',
  },
  submit: {
    login: 'Log in',
    register: 'Create Account',
    reset: 'Request Reset',
    confirm: 'Set Password',
  },
};

export const login = {
  title: 'Welcome Back',
  action: 'requestLogin',
  button: {
    label: 'Log in',
  },
  fields: {
    email: {
      type: 'email',
      label: 'Email Address',
      required: true,
      placeholder: 'Email Address',
      autocomplete: 'email',
    },
    password: {
      type: 'password',
      label: 'Password',
      placeholder: 'Password',
      required: true,
      autocomplete: 'password',
    },
  },
};

export const verify = {
  action: 'requestAccountVerification',
  button: {
    label: 'Verify account',
  },
  fields: {
    otp: {
      type: 'text',
      label: 'Verification Code',
      placeholder: 'Enter Verification Code',
      required: true,
      min: 6,
      max: 6,
      pattern: '[0-9]*',
    },
  },
};

export const register = {
  action: 'requestRegisterUser',
  button: {
    label: 'Book appointment',
  },
  fields: {
    first_name: {
      type: 'text',
      label: 'First Name',
      placeholder: 'First name',
      required: true,
      autocomplete: 'first name',
      min: 2,
    },
    last_name: {
      type: 'text',
      label: 'Last Name',
      placeholder: 'Last name',
      required: true,
      autocomplete: 'last name',
      min: 2,
    },
    birthdate: {
      type: 'date',
      label: 'Date of birth',
      // placeholder: `mm/dd/yyyy`,
      required: true,
      autocomplete: 'date of birth',
      min: 18,
    },
    gender: {
      type: 'select',
      label: 'Gender',
      placeholder: 'Gender',
      required: true,
      options: [
        {
          label: 'Male',
          value: 'M',
        },
        {
          label: 'Female',
          value: 'F',
        },
      ],
      // autocomplete: `first name`,
    },
    relationship_status: {
      type: 'select',
      label: 'Relationship status',
      placeholder: 'Relationship status',
      required: true,
      options: [
        'Never Married',
        'Married',
        'Divorced',
        'Cohabitating',
        'Separated',
        'Widowed',
        'Prefer not to say',
      ],
      // autocomplete: `first name`,
    },
    employment_status: {
      type: 'select',
      label: 'Employment status',
      placeholder: 'Employment status',
      required: true,
      options: [
        'Full Time',
        'Part Time',
        'Terminated',
        'Medical Leave',
        'Retired',
        'Disciplinary Leave',
        'Laid Off',
        'Disability/Worker’s Compensation',
        'Dependent',
      ],
      // autocomplete: `first name`,
    },
    job_title: {
      type: 'select',
      label: 'Job Title',
      placeholder: 'Job Title',
      required: true,
      options: [
        'Executive/Manager',
        'Professional',
        'Technical',
        'Sales',
        'Office/Clerical',
        'Craft Worker',
        'Operative',
        'Laborer',
        'Service Worker',
        'Dependent',
      ],
      // autocomplete: `firstName`,
    },
    org_location: {
      type: 'select',
      label: 'Which of these apply to you?',
      placeholder: 'Which of these apply to you?',
      required: true,
      options: [],
    },
    phone: {
      type: 'tel',
      label: 'Phone number',
      // placeholder: `Phone number`,
      required: true,
      autocomplete: 'tel',
    },
    address1: {
      type: 'text',
      label: 'Mailing Address Line One',
      // placeholder: `Phone number`,
      required: true,
      // autocomplete: `firstName`,
    },
    address2: {
      type: 'text',
      label: 'Mailing Address Line Two',
      // placeholder: `Phone number`,
      required: false,
      // autocomplete: `firstName`,
    },
    city: {
      type: 'text',
      label: 'City',
      // placeholder: `Phone number`,
      required: true,
      // autocomplete: `firstName`,
    },
    state: {
      type: 'select',
      label: 'State',
      placeholder: 'State',
      required: true,
      options: states,
      // autocomplete: `firstName`,
    },
    zip: {
      type: 'text',
      label: 'Zip code',
      placeholder: '12345',
      required: true,
      // autocomplete: `firstName`,
    },
    email: {
      type: 'email',
      label: 'Email address',
      placeholder: 'you@email.com',
      required: true,
      autocomplete: 'email',
    },
    password: {
      type: 'password',
      label: 'Create password',
      autocomplete: 'new-password',
      required: true,
    },
    agrees_to_beacon_privacy_notice: {
      type: 'checkbox',
      label: '',
      required: true,
      options: [
        {
          label: '<p>I have read and accept Carelon Wellbeing’s <a target="_blank" href="/privacy">Privacy Notice</a>, <a target="_blank" href="/terms">Terms of Use</a> and <a target="_blank" href="/statement-of-understanding">Statement of Understanding.</a></p>',
          value: true,
        },
      ],
    },
    agrees_to_mdlive_informed_consent: {
      type: 'checkbox',
      label: '',
      required: true,
      options: [
        {
          label: '<p>I have read <a target="_blank" href="https://www.mdlive.com/privacy-policy/">MDLIVE Medical Group\'s Privacy Policy</a> and I acknowledge that I have the ability to print a hard copy of the Privacy Policy for my records.</p>',
          value: true,
        },
      ],
    },
    agrees_to_mdlive_privacy_agreement: {
      type: 'checkbox',
      label: '',
      required: true,
      options: [
        {
          label: '<p>I certify that I have read and accept the terms of MDLIVE Medical Group\'s <a target="_blank" href="https://www.mdlive.com/informed-consent/">Informed Consent.</a></p>',
          value: true,
        },
      ],
    },
    mdlive_consent_user_initials: {
      fieldsetClasses: 'mt80 form-fieldset--initials',
      pre: 'Please acknowledge that you have read the following statements by typing your first and last initials',
      type: 'text',
      label: 'Enter initials',
      placeholder: 'Enter initials',
      required: true,
      max: 2,
    },
  },
};

export const appointmentQuery = {
  action: 'requestAppointmentQuery',
  button: {
    label: 'Submit Request',
  },
  fields: {
    preferred_time: {
      type: 'select',
      label: 'Preferred Time',
      placeholder: 'Preferred Time',
      required: true,
      options: [
        {
          label: 'First available',
          value: 'first available',
        },
        {
          label: 'Morning',
          value: 'morning',
        },
        {
          label: 'Afternoon',
          value: 'afternoon',
        },
        {
          label: 'Evening',
          value: 'evening',
        },
      ],
    },
    appointment_date: {
      type: 'date',
      label: 'Preferred Date (optional)',
      placeholder: 'Preferred Date',
      allowFuture: true,
    },
    appointment_method: {
      type: 'select',
      label: 'Preferred Method',
      placeholder: 'Preferred Method',
      required: true,
      options: [
        {
          label: 'Phone',
          value: 'phone',
        },
        {
          label: 'Video',
          value: 'video',
        },
      ],
    },
    chief_complaint_comments: {
      type: 'textarea',
      label: 'Comments (optional)',
      maxLength: 150,
      helper: 'Maximum length is 150 characters',
    },
  },
};

export const registerbooking = {
  action: 'requestScheduleAppointment',
  copy: 'We already have all your details, enter your initials below to submit your request',
  button: {
    label: 'Book appointment',
  },
  fields: {
    agrees_to_mdlive_informed_consent: {
      type: 'checkbox',
      label: '',
      required: true,
      options: [
        {
          label: '<p>I have read <a target="_blank" href="https://www.mdlive.com/privacy-policy/">MDLIVE Medical Group\'s Privacy Policy</a> and I acknowledge that I have the ability to print a hard copy of the Privacy Policy for my records.</p>',
          value: true,
        },
      ],
    },
    agrees_to_mdlive_privacy_agreement: {
      type: 'checkbox',
      label: '',
      required: true,
      options: [
        {
          label: '<p>I certify that I have read and accept the terms of MDLIVE Medical Group\'s <a target="_blank" href="https://www.mdlive.com/informed-consent/">Informed Consent.</a></p>',
          value: true,
        },
      ],
    },
    mdlive_consent_user_initials: {
      type: 'text',
      label: 'Enter initials',
      placeholder: 'Enter initials',
      required: true,
      max: 2,
    },
  },
};

export const reset = {
  action: 'requestResetPassword',
  button: {
    label: 'Reset password',
  },
  fields: {
    email: {
      type: 'email',
      label: 'Email Address',
      autocomplete: 'email',
      placeholder: 'you@email.com',
      required: true,
    },
  },
};

export const changePassword = {
  action: 'requestChangePassword',
  button: {
    label: 'Change password',
  },
  fields: {
    current_password: {
      label: 'Current Password',
      type: 'password',
      autocomplete: 'current-password',
      placeholder: 'Current Password',
      required: true,
    },
    new_password: {
      label: 'New Password',
      type: 'password',
      autocomplete: 'new-password',
      placeholder: 'New Password',
      required: true,
    },
  },
};

export const confirm = {
  action: 'requestConfirmPassword',
  button: {
    label: 'Set password',
  },
  fields: {
    new_password: {
      label: 'New Password',
      type: 'password',
      autocomplete: 'new-password',
      placeholder: 'New Password',
      required: true,
    },
  },
};



export const resetPassword = {
  action: 'requestConfirmPassword',
  button: {
    label: 'Reset password',
  },
  fields: {
    new_password: {
      label: 'New Password',
      type: 'password',
      autocomplete: 'new-password',
      placeholder: 'New Password',
      required: true,
      footNote: 'Your password must be at least eight characters and include at least one of each of the following: both upper and lower case letters, a number, and a special character. The password cannot contain spaces.',
    },
    otp2: {
      type: 'text',
      label: 'Verification Code',
      placeholder: 'Enter Verification Code',
      required: true,
      min: 6,
      max: 6,
      pattern: '[0-9]*',
    },
  },
};




export default {
  login,
  register,
  registerbooking,
  reset,
  confirm,
  verify,
  resetPassword,
  changePassword,
  appointmentQuery,
};



// WEBPACK FOOTER //
// ./client/models/auth/index.js